




























import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { masterDeviceDialogMixin } from '@/mixins'
import { IDevice } from '@/types/model'
import DeviceRadioRow from '@/components/DeviceRadioRow.vue'
import DeviceCheckboxRow from '@/components/DeviceCheckboxRow.vue'
import Pending from '@/components/Pending.vue'
import easyapi from '@/easyapi'
import { MatrixMap } from '@/store/modules/device'
import { deepCopy, getMatrixMap, devIsOnline, diff } from '@/utils'

let ORIGINAL_RX_LIST: IDevice[] = []
let ORIGINAL_TX: IDevice | null = null

export default mixins(masterDeviceDialogMixin).extend({
  components: {
    DeviceRadioRow,
    DeviceCheckboxRow,
    Pending,
  },
  data (): {
    chosenTx: IDevice | null,
    checkedRxList: IDevice[],
    nameFilterStr: string | null,
    pending: boolean,
    devIsOnline: typeof devIsOnline
  } {
    return {
      chosenTx: null,
      checkedRxList: [],
      nameFilterStr: '',
      pending: false,
      devIsOnline,
    }
  },
  computed: {
    device (): IDevice | null { return this.dialog.device }, // Remap for this device
    deviceIsTx (): boolean { return !!this.device && this.device.deviceType === 'TX' },
    commonFilteredList (): IDevice[] {
      if (!this.device) {return []}
      const vendor = this.device.vendor
      const filterStr = this.nameFilterStr
      if (!filterStr) {
        return this.$s.$state.device.list.filter((x) => x.vendor === vendor)
      }
      return this.$s.$state.device.list.filter((x) => x.vendor === vendor && x.deviceName.toLowerCase().includes(filterStr.toLowerCase()))
    },
    txList (): IDevice[] { return this.commonFilteredList.filter((x) => x.deviceType === 'TX') },
    rxList (): IDevice[] { return this.commonFilteredList.filter((x) => x.deviceType === 'RX') },
    canApply (): boolean {
      if (this.deviceIsTx) {
        return this.checkedRxList.length <= 25
      } else {
        return true
      }
    },
    fullscreen (): boolean { return this.$state.common.windowSize.width < 400 },
    matrixMap (): MatrixMap {
      return getMatrixMap(this.$state)
    }
  },
  methods: {
    clearSearch () { this.nameFilterStr = '' },
    async apply (): Promise<void> {
      if (!this.device) { return }
      let ok
      this.pending = true
      if (this.deviceIsTx) {
        const changed = diff(this.checkedRxList, ORIGINAL_RX_LIST)
        const joined = this.checkedRxList.filter(rx => !ORIGINAL_RX_LIST.includes(rx))
        const leaved = ORIGINAL_RX_LIST.filter(rx => !this.checkedRxList.includes(rx))
        // FIXME: Only apply changed
        ok = await easyapi.setMatrix([this.device, ...this.checkedRxList])
      } else {
        const tmp: IDevice[] = [this.device]
        if (this.chosenTx) {
          tmp.push(this.chosenTx)
        }
        ok = await easyapi.setMatrix(tmp)
      }
      this.pending = false
      if (ok) {
        this.closeThisDialog()
      }
    },
    isRxChecked (rx: IDevice): boolean { return this.checkedRxList.includes(rx) },
    toggleTx (dev: IDevice) {
      this.chosenTx = this.chosenTx === dev ? null : dev
    },
    toggleRxCheckbox (rx: IDevice): void {
      const pos = this.checkedRxList.indexOf(rx)
      if (pos === -1) {
        this.checkedRxList.push(rx)
      } else {
        this.checkedRxList.splice(pos, 1)
      }
    },
    clearMapForThisExtender () {
      this.chosenTx = null
      this.checkedRxList = []
    },
  },
  watch: {
    device (nv: IDevice | null, ov: IDevice | null) {
      if (nv) {
        if (nv.deviceType === 'RX' && !devIsOnline(nv)) {
          this.$router.replace({ name: 'matrix' })
          // showSnackbar(this.$t('matrix.cannotMapOfflineRx'), 'warning')
          return
        }
        // console.warn('New Device ==> ', nv.mac, nv.deviceName)
      } else {
        // console.warn('New Device ==> ', 'null')
      }
      this.chosenTx = null
      this.checkedRxList = []
      if (nv) {  // if this.device become to IDevice from null
        const oppositeType = nv.deviceType === 'TX' ? 'RX' : 'TX'
        // const oppositeDevs: IDevice[] | null = this.$store.getters['device/matrixMap'].get(nv.mac)
        const oppositeDevs = this.matrixMap.get(nv.mac)
        console.warn('opposite of ', nv.mac, '===>', oppositeDevs, 'from', this.matrixMap)
        if (!oppositeDevs) { return }
        if (oppositeType === 'TX') {
          this.chosenTx = oppositeDevs[0] || null
        } else {
          this.checkedRxList = oppositeDevs
        }
      }
      ORIGINAL_RX_LIST = Array.from(this.checkedRxList)
      ORIGINAL_TX = this.chosenTx
    },
  },
})
